import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

// Kullanıcının etiketleri (Dashboard seviyesinde bir kez yüklenir)
export const useLabels = () => {
  const [labels, setLabels] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const reload = useCallback(async () => {
    try {
      const data = await api.getLabels();
      setLabels(data.labels || []);
      setLoaded(true);
    } catch (err) {
      console.error('Failed to load labels:', err);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { labels, labelsLoaded: loaded, reloadLabels: reload };
};

export default useLabels;
